export const communityKeys = {
  donationPage: (
    keyword?: string,
    abo?: string,
    bloodProduct?: string,
    sortBy?: string
  ) => ['donation-page', keyword, abo, bloodProduct, sortBy] as const,
  boardPage: (keyword?: string) => ['board-page', keyword] as const,
  detailPage: (id: string) => ['detail-page', id] as const,
};
